import './dictionariesView.scss';
import Tabbar from "../../../components/shared/tabbar/tabbar";
import ManageDicts from "./manageDicts/manageDicts";
import ManageDictProposals from "./manageDictProposals/manageDictProposals";
import React, { useContext, useEffect, useState } from "react";
import { TabbarOption } from "../../../components/shared/tabbar/types/tabbarProps";
import { DictionariesViewTypes } from "./types/dictionariesViewProps";
import { ReactComponent as AddNotes } from "../../../icons/add_notes.svg";
import { ReactComponent as FindInPage } from "../../../icons/find_in_page.svg";
import PermissionsContext from '../../../contexts/permissionsContext';

const DictionariesView = () => {    
    const { functionsPermissions } = useContext(PermissionsContext);
    const [selectedTab, setSelectedTab] = useState<DictionariesViewTypes>(DictionariesViewTypes.ManageDicts);    
    
    useEffect(() => {
        if (!functionsPermissions.editDicts.active) setSelectedTab(DictionariesViewTypes.ManageDictProposals);

    // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [])

    // Tabbar
    const onClickOption = (navigate: number) => {
        return (event: React.SyntheticEvent<HTMLLIElement>) => {
            event.currentTarget.className = "activeTab";
            setSelectedTab(navigate);
        }
    }
    
    const renderView = (viewType: number) => {
        switch (viewType) {
            case DictionariesViewTypes.ManageDicts:
                return (<ManageDicts />)
            case DictionariesViewTypes.ManageDictProposals:
                return (<ManageDictProposals />)
        }
    }

    const iconStyleTabbar: React.CSSProperties = {
        fill: "#453F3A", 
        width: "24px", 
        height: "24px"
    }

    var Options: TabbarOption[] = [
        ...functionsPermissions.editDicts.active ? [{ name: 'Zarządzaj słownikami', additionalIcon: FindInPage, additionalIconStyle: iconStyleTabbar, onClick: onClickOption(DictionariesViewTypes.ManageDicts) }] : [],
        ...functionsPermissions.acceptRejectDictProposals.active ? [{ name: 'Propozycja zmian', additionalIcon: AddNotes, additionalIconStyle: iconStyleTabbar,  onClick: onClickOption(DictionariesViewTypes.ManageDictProposals) }] : []
    ]

    return (
        <div className="dictionariesView">
            <Tabbar selected={!functionsPermissions.editDicts.active ? 1 : selectedTab} options={Options}></Tabbar>
            {renderView(selectedTab)}
        </div>);
}

export default DictionariesView;